<template>
    <div>
        
        <div class="container-table">
            <table v-loading="!statusList" class="table table-striped">
                <thead>
                    <tr>
                        <th>Matrícula</th>
                        <th>Modalidade/Curso 2025</th>
                        <th>Aluno</th>
                        <th class="u-text-center">Data de Nascimento</th>
                        <th class="u-text-center" style="width: 150px;">
                            Situação Acadêmica
                        </th>
                        <th class="u-text-center" style="width: 300px;">
                            Nova Enturmação em 2026
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in matriculas" :key="i">
                        <td>{{ item.num_matricula }}</td>
                        <td>{{ item.curso.nome }}</td>
                        <td>{{ item.aluno.nome }}</td>
                        <td class="u-text-center">{{ $moment(item.aluno.data_nascimento).format('DD/MM/YYYY') }}</td>
                        <td class="situacao-academica"
                            :class="{ 
                                conservado: item.situacao_academica == 2 || item.situacao_academica == 4,
                                aprovado: item.situacao_academica == 1,
                                pendente: item.situacao_academica == 0 
                            }"
                        >
                            <div>
                                {{ $CONSTANTS.SITUACAO_ACADEMICA[item.situacao_academica] }}
                            </div>
                        </td>
                        <td class="select-situacao-academica">
                            <template v-if="dados[item.id] && (dados[item.id].situacao_academica == 2 || dados[item.id].situacao_academica == 4)">
                                <el-select v-model="dados[item.id].turma_id" class="select-text-center">
                                    <el-option-group v-for="(curso, i) in dados[item.id].options.turmas" :key="i" :label="i">
                                        <template v-for="itemc in curso">
                                        <el-option :key="itemc.id" :label="itemc.curso_nome + ' - ' + itemc.nome" :value="itemc.id"></el-option>
                                        </template>
                                    </el-option-group>
                                </el-select>
                            </template>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr v-if="statusList && matriculas.length == 0" style="border-top: 1px solid #ddd;">
                        <td colspan="100%" class="u-text-center">
                            <span>- nenhum registro -</span>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <el-row :gutter="10" v-if="statusButton && matriculas.length != 0">
            <el-col :xs="24" class="u-text-right u-mt-15">
                <el-button type="primary" @click="onSubmitSituacaoAcademica()">SALVAR</el-button>
            </el-col>
        </el-row>

        <el-dialog append-to-body :close-on-click-modal="false" title="ATENÇÃO" width="60%" :visible.sync="dialogAlerta">
            <div v-if="dialogAlerta">
                
                <div style="margin: 20px 0px; font-size: 16px;">
                    
                        Atenção!<br><br>

                        Existem alunos que já tiveram suas matrículas renovadas e que não foram aprovados. 
                        
                        É necessário realizar uma nova enturmação para estes alunos.

                        Você poderá obter mais detalhes assistindo ao vídeo abaixo.

                </div>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        
                        <div class='embed-container'>
                            <iframe src='https://morrochapeuapi.edugestao.com.br/videos/enturmacaoconservados.mp4' frameborder='0' allowfullscreen></iframe>
                        </div>

                    </el-col>
                </el-row>
            </div>
        </el-dialog>

    </div>
</template>
<script>

import Vue from 'vue'

export default {
    data: () => ({
        dialogAlerta: false,
        statusButton: false,
        statusList: true,
        filtro: {
            curso_id: '',
            turma_id: ''
        },
        dados: {},
        selectCursos: [],
        selectTurmas: [],
        matriculas: [],
        todos: ''
    }),
    mounted(){
        
      this.getMatriculasByTurma()
    },
    methods: {

        getMatriculasByTurma(){

            this.todos = '';
            this.statusList = false;

            this.dados = {};
            this.matriculas = [];

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAllByTurmaForSituacaoAcademica/` + this.$route.params.id, this.$store.getters.getHeaderAuth).then(response => {
                
                let conservados = [];
                for(let i in response.data){
                    if((response.data[i].situacao_matricula == 1 || response.data[i].situacao_matricula == 4) && (response.data[i].situacao_academica == 2 || response.data[i].situacao_academica == 4 || response.data[i].situacao_academica == 5)) {
                        conservados.push(response.data[i].id);
                    }
                }

                for(let i in response.data){
                    Vue.set(this.dados, response.data[i].id, { turma_id: '', situacao_academica: response.data[i].situacao_academica, options: {} });
                }

                this.buscaOptions(conservados);
                
                this.matriculas = response.data;
                this.statusList = true;
                this.statusButton = true;
 
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        buscaOptions(conservados){
         
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/turma/getAllForEnturmacaoConservados`, { ids: conservados }, this.$store.getters.getHeaderAuth).then(response => {
               
                if(typeof response.data.erro !== 'undefined'){

                    this.$alert(response.data.erro, 'Atenção', {
                        confirmButtonText: 'OK',
                        type: 'warning'
                    }).catch(()=>{});
                    window.eventBus.$emit('loading', false);

                }else{

                    for(let i in response.data) {

                        this.dados[i].turma_id = '';
                        this.dados[i].options = {};

                        this.dados[i].options = response.data[i];
                    }
                }

            }).catch((error) => { this.$store.commit('throwException', error); });


        },
        onSubmitSituacaoAcademica(){

            for(let i in this.dados){

                if(
                    (
                        (
                            this.dados[i].situacao_academica == 2 || 
                            this.dados[i].situacao_academica == 4 || 
                            this.dados[i].situacao_academica == 5 
                        ) 
                            &&
                        Object.keys(this.dados[i].options).length !== 0 
                            &&
                        this.dados[i].options.turmas.length == 0 
                    ) ||
                    (
                        Object.keys(this.dados[i].options).length !== 0 &&
                        this.dados[i].options.turmas.length != 0 &&
                        !this.dados[i].turma_id
                    )
                ){      
                    
                    this.dialogAlerta = true;
                    return false;
                }

            }
            
            this.$msgbox.confirm('Tem certeza que deseja continuar?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                let payload = {
                    ids: this.dados,
                    turma_anterior_id: this.$route.params.id
                }
                    
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/storeEnturmacaoFechamento`, payload, this.$store.getters.getHeaderAuth).then(response => {
                            
                    if(typeof response.data.erro !== 'undefined'){

                        this.$alert(response.data.erro, 'Atenção', {
                            confirmButtonText: 'OK',
                            type: 'warning'
                        }).catch(()=>{});
                        window.eventBus.$emit('loading', false);

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.$router.push(`/admin/turma/situacao-academica-turmas`);  
                    }
                    
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
           
        }
    }
}
</script>
<style>

    .situacao-academica {
        text-align: center;
    }

    .select-situacao-academica{
        padding: 0px !important;
    }

    .select-situacao-academica .conservado .el-input__inner{
        
        background-color: #ffc5c5;
        color: #313131;
    }

    .select-situacao-academica .aprovado .el-input__inner{
        
        background-color: #99ff99;
        color: #313131;
    }

    .select-situacao-academica .transferido .el-input__inner{
        
        background-color: #f3ea87;
        color: #313131;
    }

    .select-situacao-academica .el-input__inner::placeholder{
        
        color: #313131;
    }

    .select-situacao-academica .disabled{
        
        text-align: center;
        border-left: 1px solid #cccccc;
        border-right: 1px solid #cccccc;
        height: 30px;
        /* padding-left: 15px; */
        line-height: 36px;
        background-color: #e3e3e3;
    }

    .select-text-center .el-input__inner{
        text-align: center !important;
    }

    .aprovado {
        background-color: #e3fde3;
    }

    .conservado {
        background-color: #ffecec;
    }

    .pendente {
        background-color: #fffeec;
    }
  
</style>